import React from 'react';
import { Check } from 'lucide-react';
export function Participation() {
  const actions = ['Leer la agenda.', 'Asistir a una reunión.', 'Enviar una pregunta.', 'Reportar un problema.', 'Compartir una alerta.', 'Ser voluntario en un proyecto.', 'Invitar a otro vecino a participar.'];
  return <section className="py-24 px-6 lg:px-8 bg-charcoal text-white overflow-hidden relative" data-id="element-364">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-365">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-charcoal-light rounded-full opacity-20 blur-3xl" data-id="element-366"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-sky rounded-full opacity-10 blur-3xl" data-id="element-367"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-368">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-369">
          <div data-id="element-370">
            <h2 className="text-3xl md:text-5xl font-bold text-softblue mb-6 leading-tight" data-id="element-371">
              Participación Comunitaria
            </h2>
            <p className="text-xl text-warm font-medium mb-8" data-id="element-372">
              Una comunidad fuerte se construye con vecinos informados y
              activos.
            </p>

            <div className="space-y-4 text-lg text-softblue-dark mb-8" data-id="element-373">
              <p data-id="element-374">No necesitas ser experto.</p>
              <p data-id="element-375">No necesitas haber asistido antes.</p>
              <p data-id="element-376">No necesitas representar a una organización.</p>
            </div>

            <div className="bg-charcoal-light/40 p-6 rounded-xl border border-charcoal-light" data-id="element-377">
              <p className="text-xl font-bold text-softblue mb-2" data-id="element-378">
                Cada acción cuenta.
              </p>
              <p className="text-softblue-dark" data-id="element-379">
                Cuando más personas participan, la comunidad tiene más
                información, más representación y más fuerza para organizarse.
              </p>
            </div>
          </div>

          <div className="bg-sylmar-light text-charcoal p-8 md:p-10 rounded-3xl shadow-2xl border border-sylmar/10" data-id="element-380">
            <h3 className="text-2xl font-bold mb-6" data-id="element-381">
              Puedes empezar con algo simple:
            </h3>
            <ul className="space-y-4" data-id="element-382">
              {actions.map((action, index) => <li key={index} className="flex items-center gap-3 text-lg font-medium" data-id="element-383">
                  <div className="bg-sky/20 p-1 rounded-full text-sky-dark shrink-0" data-id="element-384">
                    <Check className="w-5 h-5" data-id="element-385" />
                  </div>
                  {action}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}